import axios from 'axios'

export default {
  create: (context, payload) => {
    // eslint-disable-next-line no-unused-vars
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.post('url', payload)
        .then(response => {
          const { data } = response

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  list: (context, payload) => {
    const { commit } = context

    return new Promise((resolve, reject) => {
      axios.get('url', {
        params: payload,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          const rows = response.data

          commit('setItems', rows)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
